import { render, staticRenderFns } from "./TotalPurchasedScannedProductsIndicator.vue?vue&type=template&id=0c770b24&scoped=true"
import script from "./TotalPurchasedScannedProductsIndicator.vue?vue&type=script&lang=js"
export * from "./TotalPurchasedScannedProductsIndicator.vue?vue&type=script&lang=js"
import style0 from "./TotalPurchasedScannedProductsIndicator.vue?vue&type=style&index=0&id=0c770b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c770b24",
  null
  
)

export default component.exports